// prutl-frontend-npm6node14/src/pages/PrutlFrameworkDimensionManagement.jsx

import React from 'react';
import PrutlFrameworkDimensionList from '../components/prutlFrameworkDimensionManagement/PrutlFrameworkDimensionList.jsx';

const PrutlFrameworkDimensionManagement = () => {
  return (
    <div className="prutlFrameworkDimensionManagementContainer">
      <h1>PRUTL Framework Dimension Management</h1>
      <PrutlFrameworkDimensionList />
    </div>
  );
};

export default PrutlFrameworkDimensionManagement;
